import React from "react";
import { useTranslation } from "react-i18next";
import { TabV2, TabsList, TabsTrigger, TabsContent } from "../TabV2/TabV2";
import BlockedDatesForm from "../BlockedDatesForm/BlockedDatesForm";

type Props = {
  defaultDate?: Date;
  onClose: () => void;
  timeZone?: string;
};

const BlockedDatesModal: React.FC<Props> = ({ defaultDate, onClose, timeZone }) => {
  const { t } = useTranslation();
  const refresh = () => onClose();

  return (
    <div className="flex flex-col">
      <TabV2 defaultValue="global" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="global">
            {t("calendar.blocked_dates.tab.global_blocks")}
          </TabsTrigger>
          <TabsTrigger value="single_fitting_room">
            {t("calendar.blocked_dates.tab.single_fitting_room_blocked")}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="global">
          <BlockedDatesForm
            defaultDate={defaultDate}
            fn={refresh}
            timeZone={timeZone}
            variant="global"
          />
        </TabsContent>
        <TabsContent value="single_fitting_room">
          <BlockedDatesForm
            defaultDate={defaultDate}
            fn={refresh}
            timeZone={timeZone}
            variant="single_fitting_room"
          />
        </TabsContent>
      </TabV2>
    </div>
  );
};

export default BlockedDatesModal;
